import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { Onboarding } from '@/components/layout/Onboarding';
import { cn } from '@/utils/cn';

type LoginLayoutProps = PropsWithChildren<{
  title: string;
  description?: string;
  descriptionClassName?: string;
  portalTitle?: string;
  portalDescription?: string;
  portalDescriptionClassName?: string;
}>;

export function LoginLayout({
  title,
  description,
  descriptionClassName,
  portalTitle,
  portalDescription,
  portalDescriptionClassName,
  children,
}: LoginLayoutProps) {
  const { t } = useTranslation();

  return (
    <Onboarding
      title={title}
      description={description}
      descriptionClassName={descriptionClassName}
    >
      <div className="auth-shell__login-stack">
        <p className="auth-shell__portal-title">{portalTitle ?? t('auth.portalLabel')}</p>
        {portalDescription ? (
          <p className={cn('auth-shell__portal-description', portalDescriptionClassName)}>{portalDescription}</p>
        ) : null}
        <div className="auth-card">{children}</div>
      </div>
    </Onboarding>
  );
}
